import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils'
import { useCallback } from 'react'

export const CustActiveList = ({ custId }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!custId) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('custId', custId));
  }, [custId]);

  return (
    <EntityList entity="CUST_ACTIVE" augRowsReq={augRowsReq} />
 )
}
